import { render, staticRenderFns } from "./Tinker.vue?vue&type=template&id=593f1672&"
import script from "./Tinker.vue?vue&type=script&lang=js&"
export * from "./Tinker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports